import {
    REQUEST_FORMS,
    RECEIVE_FORMS,
    REQUEST_CONVERSIONTABLE,
    RECEIVE_CONVERSIONTABLE,
    EMAIL_EDIT_SHOW_MODAL,
    EMAIL_EDIT_HIDE_MODAL,
} from '../actions'

import _ from "lodash";

function forms(state = {
    isFetching: false,
    isFetchingForms: false,
    formsList: [],
    conversionTable: [],
    emailEditShowModal: false,
    emailEditFormId: undefined
}, action) {
    switch (action.type) {
        case REQUEST_FORMS:
            return Object.assign({}, state, {
                isFetching: true,
                isFetchingForms: true
            });
        case RECEIVE_FORMS:
            return Object.assign({}, state, {
                isFetching: false,
                isFetchingForms: false,
                formsList: action.forms,
            });
        case REQUEST_CONVERSIONTABLE:
            return Object.assign({}, state, {
                isFetching: true
            });
        case RECEIVE_CONVERSIONTABLE:
            return Object.assign({}, state, {
                isFetching: false,
                // Remove all that have no conversion value. Useless.
                conversionTable: _.filter(action.forms, function (o) {
                    return !(_.isNull(o.conversion));
                })
            });
        case EMAIL_EDIT_SHOW_MODAL:
            return Object.assign({}, state, {
                emailEditShowModal: true,
                emailEditFormId: action.emailEditFromid
            });
        case EMAIL_EDIT_HIDE_MODAL:
            return Object.assign({}, state, {
                emailEditShowModal: false,
                emailEditFormId: undefined
            });

        default:
            return state
    }
}

export default forms


// WEBPACK FOOTER //
// ./src/reducers/forms.js